interface BrandLogoProps {
  variant?: 'symbol' | 'full';
  className?: string;
}

export default function BrandLogo({ variant = 'symbol', className = '' }: BrandLogoProps) {
  const src = `${import.meta.env.BASE_URL}${variant === 'full' ? 'logo-full.svg' : 'logo-symbol.svg'}`;
  return <img src={src} alt="Gather System" className={className} />;
}
